export function generateTransactionId() {
  return Math.random().toString(36).slice(2);
}

const runtimeStaticTransactionId = generateTransactionId();

export function transactionId() {
  return `${runtimeStaticTransactionId}_${generateTransactionId()}`;
}
